import React, { forwardRef, Ref, useState } from 'react';
import { NavPanel, NavPanelRefType } from '../navpanel';
import { ApplicationMenuButton } from './ApplicationMenuButton';
import { ApplicationNavPanelMenuDrawer } from './ApplicationNavPanelMenuDrawer';

/**
 * {@docCategory ApplicationNavPanel}
 */
export interface ApplicationNavPanelProps {
   title: string;
}

export declare type ApplicationNavPanelPropsWithChildren = React.PropsWithChildren<ApplicationNavPanelProps>;

export const ApplicationNavPanel = forwardRef<NavPanelRefType, ApplicationNavPanelPropsWithChildren>(
   (props: ApplicationNavPanelPropsWithChildren, ref: Ref<NavPanelRefType>) => {
      const [menuVisible, setMenuVisible] = useState(false);

      const onClose = React.useCallback(() => {
         setMenuVisible(false);
      }, [setMenuVisible]);

      const menuButton = <ApplicationMenuButton setMenuVisible={setMenuVisible}/>;

      return (
         <>
            <NavPanel
               title={props.title}
               rootNavBarLeftItem={menuButton}
               ref={ref}
            >
               {props.children}
            </NavPanel>

            <ApplicationNavPanelMenuDrawer visible={menuVisible} setVisible={setMenuVisible}/>
         </>
      );
   });
